export const DB_PREFIX = 'identity';
export const TITLE = 'Official documents';
export const DESCRIPTION = 'Passport / driving license';
